import routes from '@/routes';

Alpine.data('alpine_cookies', () => ({
  loading: false,

  isLoading() {
    return this.loading;
  },

  async accept() {
    this.loading = true;

    await window.axios.get(routes['cookies.accept'])
      .catch(error => {
        window.console.error(error);

        this.loading = false;
      })
      .finally(() => {
        document.getElementById('accept-cookies')
          .classList
          .add('opacity-0');

        setTimeout(() => {
          document.getElementById('accept-cookies').remove();
        }, 300);
      });
  },
}));
